import { SEARCH_TERM_TYPE } from 'analytics/list-search-tracking';
import type { Eligibility, ItemId } from 'api/definitions/intelligent-shopping-experience/types';
import type { LegacyProductReference } from 'constants/products';
import type { RecommendedSelectionWithKey } from 'redux/transforms/types';

export type ShopByListEligibilityInitialState = Record<string, never>;
export type ShopByListEligibilityRequestState = { loading: boolean };
export type ShopByListEligibilitySuccessState = Eligibility & { loading: boolean };

export type ShopByListEligibilityState =
  | ShopByListEligibilityInitialState
  | ShopByListEligibilityRequestState
  | ShopByListEligibilitySuccessState;

export enum ShopByListProcessingPhase {
  IDLE = 'IDLE',
  EXTRACTING_SEARCH_TERMS = 'EXTRACTING_SEARCH_TERMS',
  NO_RESULTS = 'NO_RESULTS',
  STREAMING_SUGGESTIONS = 'STREAMING_SUGGESTIONS',
  EXTRACTING_ADDITIONAL_SEARCH_TERMS = 'EXTRACTING_ADDITIONAL_SEARCH_TERMS',
}

export enum ShopByListSuggestionsStatus {
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
}

export type ShopByListItemState = {
  candidates: LegacyProductReference[];
  itemId: ItemId;
  originalSearchTerm: string;
  searchTerm: string;
  searchTermType: SEARCH_TERM_TYPE;
  suggestionsStatus: ShopByListSuggestionsStatus;
};

export type ShopByListProcessingInitialState = Record<string, never>;
export type ShopByListProcessingActiveState = {
  phase: ShopByListProcessingPhase;
  itemOrder: ItemId[];
  itemsById: Record<ItemId, ShopByListItemState>;
  recommendedSelection: RecommendedSelectionWithKey[];
  estimatedPriceLoading?: boolean;
  estimatedPrice?: number;
};

export type ShopByListProcessingState =
  | ShopByListProcessingInitialState
  | ShopByListProcessingActiveState;

export type ViewAllModalProductsState = {
  currentItemId?: ItemId;
  currentSearchTerm?: string;
  hasError: boolean;
  isLoading: boolean;
  products: LegacyProductReference[];
  requestId?: string;
};

export type ShopByListState = {
  eligibility: ShopByListEligibilityState;
  processing: ShopByListProcessingState;
  viewAllModalProducts: ViewAllModalProductsState;
  upload?: {
    sessionId: string;
    uploadCode: string;
    initiated: boolean;
  };
};

export type UpdateShopByListItem = Pick<ShopByListItemState, 'itemId' | 'searchTerm'>;
